import { Trans, useTranslation } from "react-i18next";

import { Link } from "@/components/Interface/Link/Link";
import { Notification } from "@/components/Interface/Notification/Notification";

export const RequestInvoicePanel = () => {
  const { t } = useTranslation();

  return (
    <Notification
      dataTestid="invoice-request-description"
      title={t("Content.goodToKnow")}
      description={
        <Trans
          i18nKey="user-account.paymentMethods.requestPaymentViaInvoice"
          components={[
            <Link
              href={t(
                "user-account.paymentMethods.requestPaymentViaInvoiceLink",
              )}
              key="linkToRequest"
              size="sm"
              target="_blank"
              rel="noreferrer"
            />,
          ]}
          t={t}
        />
      }
    />
  );
};
